import DocumentCamera from './DocumentCamera';

export default DocumentCamera;
